import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { isEmpty, omit, toArray, toPlainObject, values } from 'lodash';

import {
    FILTER_PARTNER_ON_CATEGORY,
    FILTER_PARTNER_ON_FIRST_LETTER,
    SORT_PARTNER_ON_NAME,
    SORT_PARTNER_ON_CASHBACK,
    SORT_PARTNER_ON_CASHBACK_OFFLINE,
    SORT_PARTNER_ON_CASHBACK_EBON,
    SORT_PARTNER_ON_ORDER,
    SORT_PARTNER_ON_CREATION_DATE,
    SORT_PARTNER_ON_NB_COUPON
} from '../../../services/filter/constants';
import { HIDE_ALO } from '../../../constants';
import { PATH } from '../../../constants/path';
import { MODAL_TYPE_LOGIN } from '../../../services/modal/constants';

import { showModal } from '../../../services/modal/actions';

import {
    sortOnOrder,
    sortOnCreationDate,
    sortOnCashback,
    sortOnCashbackOffline,
    sortOnCashbackEbon,
    sortOnName,
    sortOnNbCoupon,
    filterOnCategory,
    filterOnCategoryEbon,
    filterOnFirstLetter
} from '../../../services/partner/selector';

import {
    hasCashback,
    hasCoupon,
    hasOffline,
    hasCashbackOffline,
    hasEbon,
    hasEbonCashback
} from '../../../services/partner/utils';

import ABCBookComponent from './ABCBookComponent';
import FilterComponent from './filter/FilterComponent';
import GridDirectoryComponent from './GridDirectoryComponent';
import LinkButtonComponent from '../../button/LinkButtonComponent';
import HowItWorksComponent from '../../../components/HowItWorksComponent';

import './DirectoryPage.scss';

class DirectoryPage extends React.Component {
    sortPartners = (sorter, partners) =>
        sorter
            ? partners.sort(
                  (type => {
                      switch (type) {
                          case SORT_PARTNER_ON_NAME:
                              return sortOnName;
                          case SORT_PARTNER_ON_CASHBACK:
                              return sortOnCashback;
                          case SORT_PARTNER_ON_CASHBACK_OFFLINE:
                              return sortOnCashbackOffline;
                          case SORT_PARTNER_ON_CASHBACK_EBON:
                              return sortOnCashbackEbon;
                          case SORT_PARTNER_ON_ORDER:
                              return sortOnOrder;
                          case SORT_PARTNER_ON_CREATION_DATE:
                              return sortOnCreationDate;
                          case SORT_PARTNER_ON_NB_COUPON:
                              return sortOnNbCoupon;
                          default:
                              return () => 1;
                      }
                  })(sorter.type)
              )
            : partners;

    filterPartners = (filter, partners, isEbon) =>
        filter
            ? partners.filter(p =>
                  (type => {
                      switch (type) {
                          case FILTER_PARTNER_ON_FIRST_LETTER:
                              return filterOnFirstLetter;
                          case FILTER_PARTNER_ON_CATEGORY:
                              if (isEbon) {
                                  return filterOnCategoryEbon;
                              } else {
                                  return filterOnCategory;
                              }
                          default:
                              return () => () => true;
                      }
                  })(filter.type)(filter.args)(p)
              )
            : partners;

    filterActivity = (partners, isCodePromo, isOffline, isEbon) =>
        isCodePromo
            ? partners.filter(partner => hasCoupon(partner))
            : isOffline
            ? partners.filter(partner => hasOffline(partner) && hasCashbackOffline(partner))
            : isEbon
            ? partners.filter(partner => hasEbon(partner) && hasEbonCashback(partner))
            : partners.filter(partner => hasCashback(partner));

    renderTitle = category => {
        const { letter, i18nPage, isOffline, isEbon } = this.props;

        if (isEmpty(category) && !letter) {
            if (isOffline) {
                return <h1>{i18nPage.MOST_POPULAR.OFFLINE_TITLE}</h1>;
            } else if (isEbon) {
                return <h1>{i18nPage.MOST_POPULAR.EBON_TITLE}</h1>;
            } else {
                return <h1>{i18nPage.MOST_POPULAR.ONLINE_TITLE}</h1>;
            }
        } else if (!isEmpty(category) && !letter) {
            return <h1>{category.label}</h1>;
        } else {
            return <h1>{i18nPage.A_Z.PAGE_TITLE}</h1>;
        }
    };

    showLoginModal = () => event => {
        const { isAuthenticated, showModal } = this.props;
        if (!isAuthenticated) {
            event.preventDefault();
            showModal(MODAL_TYPE_LOGIN);
            return false;
        }
    };

    render() {
        const {
            i18nPage,
            partners,
            filter = {},
            sorter = {},
            fetching,
            ebonPartnersFetching,
            categories,
            categoryId,
            letter,
            isCodePromo = false,
            Breadcrumb,
            isOffline,
            ebonPartners,
            isEbon
        } = this.props;

        const category = toPlainObject(categories[categoryId]);

        const fetchingType = isEbon ? ebonPartnersFetching : fetching;
        const partnerTypeList = isEbon ? ebonPartners : partners;
        const filteredPartners = this.filterPartners(filter, partnerTypeList, isEbon);
        const partnerList = this.sortPartners(
            sorter,
            this.filterActivity(filteredPartners, isCodePromo, isOffline, isEbon)
        );

        return (
            <div className="flex-container-v">
                {Breadcrumb && <Breadcrumb />}

                <main className="conteneur conteneur-mobile" id="p-annuaire">
                    <div className="directory-head">
                        <div>{this.renderTitle(category)}</div>
                        {isOffline && !HIDE_ALO && (
                            <div className="button-row">
                                <LinkButtonComponent
                                    to={PATH.ALO_PATH}
                                    text={i18nPage.ALO_BUTTON}
                                    title={i18nPage.ALO_BUTTON}
                                    color="sixth"
                                    onClick={this.showLoginModal()}
                                />
                            </div>
                        )}
                    </div>
                    <FilterComponent
                        partners={partnerList}
                        categoryId={!isEmpty(category) ? category.id : -1}
                        categories={values(categories)}
                        isCodePromo={isCodePromo}
                        isOffline={isOffline}
                        isEbon={isEbon}
                    />
                    <ABCBookComponent
                        isCodePromo={isCodePromo}
                        letter={letter}
                        isOffline={isOffline}
                        isEbon={isEbon}
                    />
                    <GridDirectoryComponent
                        partners={partnerList}
                        fetching={fetchingType}
                        isCodePromo={isCodePromo}
                        isOffline={isOffline}
                        isEbon={isEbon}
                    />
                </main>
                <HowItWorksComponent
                    topShadow
                    showTitle
                    cssClass="conteneur conteneur-mobile"
                    isOffline={isOffline}
                    isEbon={isEbon}
                />
            </div>
        );
    }
}

DirectoryPage.propTypes = {
    categoryId: PropTypes.number,
    letter: PropTypes.string,
    isCodePromo: PropTypes.bool,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool,
    partners: PropTypes.array.isRequired,
    fetching: PropTypes.bool.isRequired,
    categories: PropTypes.object.isRequired
};

const mapStateToProps = (state, props) => {
    const category = Number((/-(\d*)$/.exec(window.location.pathname) || [])[1]) || null;
    const partners = toArray(state.partner.partners).filter(p =>
        category ? p.categoriesIds.indexOf(category) > -1 : true
    );
    return {
        isAuthenticated: state.authentication.isAuthenticated,
        partners,
        ebonPartners: state.ebon.ebonPartners,
        fetching: state.partner.fetching,
        ebonPartnersFetching: state.ebon.ebonPartnersFetching,
        categories: toPlainObject(omit(state.category.categories, 'loading')),
        filter: (state.filters.directory || {}).filter,
        sorter: (state.filters.directory || {}).sorter,
        i18nPage: state.i18n.page.DIRECTORY
    };
};

const mapDispatchToProps = {
    showModal
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DirectoryPage));



// WEBPACK FOOTER //
// ./src/components/pages/directory/DirectoryPage.js